import { render } from "./AddClientView.vue?vue&type=template&id=35091b69"
import script from "./AddClientView.vue?vue&type=script&lang=js"
export * from "./AddClientView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__